import StretchingAsset from "./StretchingAsset";

export default StretchingAsset;
